import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import SafeLifeLogo from "../components/SafeLifeLogo";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) {
    // Already logged
    navigate("/admin/cotacoes", { replace: true });
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Bem-vindo(a) ao painel Safe Life.");
      navigate("/admin/cotacoes");
    } else {
      setError(res.error || "Falha ao entrar");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface py-12 px-4" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <Link to="/" className="flex justify-center mb-8">
          <SafeLifeLogo className="h-16" />
        </Link>

        <div className="bg-white rounded-3xl p-8 md:p-10 border border-navy-100 shadow-soft">
          <p className="text-lego text-xs font-bold uppercase tracking-widest mb-2">Área interna</p>
          <h1 className="font-heading text-3xl font-extrabold text-navy">Painel Safe Life</h1>
          <p className="text-navy/60 mt-2 text-sm">
            Entre para gerenciar as cotações recebidas.
          </p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <Label>E-mail</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="admin@safelifeseguros.com.br"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label>Senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-login-password"
              />
            </div>

            {error && (
              <p className="text-sm text-lego bg-lego/10 rounded-xl p-3" data-testid="admin-login-error">
                <i className="fa-solid fa-circle-exclamation mr-2" /> {error}
              </p>
            )}

            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-lego hover:bg-lego/90 text-white rounded-full h-12 font-bold"
              data-testid="admin-login-submit"
            >
              {submitting ? (
                <><i className="fa-solid fa-spinner fa-spin mr-2" /> Entrando...</>
              ) : (
                <>Entrar <i className="fa-solid fa-arrow-right ml-2" /></>
              )}
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-navy/40 mt-6">
          <Link to="/" className="hover:text-navy">← Voltar ao site</Link>
        </p>
      </div>
    </div>
  );
}
